import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// SERVICES
// import { ThemeService } from './services/theme.service';
// import { NavigationService } from "./services/navigation.service";
// import { RoutePartsService } from './services/route-parts.service';
// import { AuthGuard } from './guards/auth.guard';
// import { UserRoleGuard } from './guards/user-role.guard';
// import { AppConfirmService } from './services/app-confirm/app-confirm.service';
// import { AppLoaderService } from './services/app-loader/app-loader.service';

import { SharedComponentsModule } from './components/shared-components.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { TgssDatepickerModule } from './components/tgss-datepicker/tgss-datepicker.module';
import { TgssSelectFilterModule } from './components/tgss-select-filter/tgss-select-filter.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { CarouselModule } from 'ngx-owl-carousel-o';
// import { SliderDirectionService } from 'app/core/services/slider-direction-service';
import { PhotoSwipeService } from 'app/core/services/photo-swipe.service';
import { TableloaderModule } from './components/tableloader/tableloader.module';
@NgModule({
  imports: [
  CommonModule,
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    TgssDatepickerModule,
    TgssSelectFilterModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    DragulaModule,
    CarouselModule
  ],
  providers: [DragulaService,PhotoSwipeService ],
  exports: [
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    TgssDatepickerModule,
    TgssSelectFilterModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    DragulaModule,
    CarouselModule,
    TableloaderModule,
  ]
})
export class SharedModule { }
